// 用於預先取得所有的彩票類型、這樣在前台就可以減少api 的呼叫次數
export default async({ store }) => {
  // await store.dispatch('lottery/getLotteryMap')
}
